import { render, staticRenderFns } from "./VideoRequestViewDialog.vue?vue&type=template&id=bfdc65e6&"
import script from "./VideoRequestViewDialog.vue?vue&type=script&lang=ts&"
export * from "./VideoRequestViewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
